import { createApi } from "@reduxjs/toolkit/query/react";

import type { ModulesDTO } from "../../../../common/types/ModulesDTO";
import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

export const moduleService = createApi({
  reducerPath: "moduleService",
  baseQuery: createServiceBaseQuery("bffApiUri"),
  tagTypes: ["Modules"],
  endpoints: (builder) => ({
    getModules: builder.query<ModulesDTO, { userId: number }>({
      query: ({ userId }) => `api/modules/${userId}`,
      providesTags: [{ type: "Modules" }],
    }),
  }),
});

export const { useGetModulesQuery } = moduleService;
